<template>
    <Modal v-on="$listeners">
        <section class="video">
            <Player :id="project.id" rounded/>
        </section>
        <section class="infos">
            <div class="text">
                <h4>{{ project.title }}</h4>
                <p>{{ project.description }}</p>
                <p><i>{{ date }}</i></p>
            </div>
            <div class="actions">
                <ul>
                    <li>
                        <a @click.stop="onShareFacebook">
                            <IconFacebook :color="config.COLOR_PRIMARY"/>
                        </a>
                    </li>
                    <li>
                        <a @click.stop="onShareTwitter">
                            <IconTwitter :color="config.COLOR_PRIMARY"/>
                        </a>
                    </li>
                    <li v-if="project.lastOutput">
                        <a
                            :href="project.lastOutput.url"
                            :download="project.lastOutput.filename"
                            target="_blank"
                            @click="(e) => e.stopPropagation()"
                        >
                            <IconDownload :color="config.COLOR_PRIMARY"/>
                        </a>
                    </li>
                </ul>
            </div>
        </section>
    </Modal>
</template>
<script>
import { SocialConsumer, SolutionConsumer, ProjectConsumer } from '../../mixins';
import { Player } from '../../components/shared';

export default {
    name: 'ModalProject',
    components: { Player },
    mixins: [SocialConsumer, SolutionConsumer, ProjectConsumer],
    props: {
        project: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        date () {
            return new Date(this.project.createdAt * 1000).toLocaleDateString();
        },
    },
    methods: {
        onShareFacebook () {
            this.shareFacebook(this.getPlayerFrontURL(this.project.id));
        },
        onShareTwitter () {
            this.shareTwitter(this.getPlayerFrontURL(this.project.id));
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

section {
    &.infos {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > .actions {
            > ul {
                @include ul-horizontal(10px);
                width: max-content;

                > li {
                    &:hover {
                        filter: brightness(1.1);
                    }

                    > a {
                        @include a-reset();
                        cursor: pointer;

                        > svg {
                            @include square(16px);
                        }
                    }
                }
            }
        }
    }
}
</style>
